import { AppEvent } from 'types/appEvent';
import { CardPaymentManager } from 'types/cardPaymentManagerTypes';
import {
  createCardPaymentManager,
  createCardPaymentManagerData,
} from 'utils/cardPaymentManagerUtils';
import { createReducer } from 'utils/reducer/reducerUtils';

export const reduceToNextCardPaymentManager = createReducer<
  CardPaymentManager,
  AppEvent
>((prev, event) => {
  switch (event.name) {
    case 'CardPaymentManager__Closed':
      return createCardPaymentManager();
    case 'CardPaymentManager__DataRecieved':
      const { cardPayment } = event;

      if (cardPayment) {
        return {
          ...prev,
          data: {
            ...prev.data,
            cardPaymentInvalidated: false,
            cardPayment,
          },
        };
      }

      return prev;
    case 'CardPaymentsPage__TableItemClicked':
      return {
        ...createCardPaymentManager(),
        data: {
          ...createCardPaymentManagerData(),
          cardPaymentInvalidated: true,
        },
        cardPaymentId: event.itemId,
      };
    case 'ClientDetails__ManageCardPayment': {
      return {
        ...createCardPaymentManager(),
        data: {
          ...createCardPaymentManagerData(),
          cardPaymentInvalidated: true,
        },
        cardPaymentId: event.paymentId,
      };
    }
    case 'CardPaymentsPage__ClientDetailsWillBeShown':
      return createCardPaymentManager();
    default:
      return prev;
  }
});
